export interface INotificationsHOCProps {
    isNotificationsOpen: boolean;
    updateNotificationsOpen: (value: boolean) => void;
}

export enum ECloseHintSource {
    NOT_NOW = 'not now',
    CLOSE = 'close'
}
